import { render, staticRenderFns } from "./ranking-elements-list.component.vue?vue&type=template&id=66c3cca6&scoped=true"
import script from "./ranking-elements-list.component.vue?vue&type=script&lang=ts"
export * from "./ranking-elements-list.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c3cca6",
  null
  
)

export default component.exports